<template>
  <div
    v-click-outside="{ handler: () => isDropdownVisible = false }"
    class="relative inline-block"
  >
    <button
      type="button"
      class="p-2 hover:text-orange-mia focus:outline-none relative"
      :class="{
        'text-gray-900': !isDropdownVisible,
        'text-orange-mia': isDropdownVisible,
      }"
      title="Sichtbare Spalten konfigurieren"
      @click="isDropdownVisible = !isDropdownVisible"
    >
      <mia-streamline-icon
        class="w-5 h-5 fill-current"
        src="filter-1"
      />
      <span
        v-if="isFiltered"
        class="absolute inline-block top-0 right-0 pointer-events-none bg-orange-mia rounded-full"
        style="width: 0.375rem; height: 0.375rem"
      />
    </button>

    <mia-scale-in-transition>
      <div
        v-if="isDropdownVisible"
        class="absolute left-0 z-50 w-64 mt-2 origin-top-right rounded-md shadow-lg"
      >
        <div class="bg-white rounded-md shadow-xs">
          <div
            class="py-1 overflow-x-hidden overflow-y-auto"
            style="max-height: 350px;"
          >
            <button
              type="button"
              class="px-3 py-2 focus:outline-none"
              :class="{
                'hover:text-orange-mia hover:underline': isFiltered,
                'text-gray-700 cursor-default': !isFiltered,
              }"
              :style="{ opacity: isFiltered ? 1 : 0.6 }"
              @click="onRestoreDefaultsClick"
            >
              Standard wiederherstellen
            </button>

            <label
              v-for="item in config"
              :key="item.column"
              class="items-center flex w-full pl-3 pr-1 mb-0 overflow-hidden font-normal whitespace-no-wrap cursor-pointer hover:bg-gray-200"
              :class="{ 'pointer-events-none': !item.isToggleable }"
              :style="{ opacity: item.isToggleable ? 1 : 0.6 }"
              style="text-overflow: ellipsis; padding-top: 0.375rem; padding-bottom: 0.375rem"
            >
              <mia-checkbox
                :checked="isItemChecked(item)"
                @input="onCheck(item, $event)"
              />
              <span
                class="ml-2"
                v-text="item.label"
              />
            </label>
          </div>
        </div>
      </div>
    </mia-scale-in-transition>
  </div>
</template>

<script>
import findIndex from 'lodash/findIndex'

export default {
  name: 'MiaDatatableColumnFilter',

  props: {
    value: {
      type: Array,
      required: true
    },

    config: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      isDropdownVisible: false
    }
  },

  computed: {
    isFiltered() {
      return this.config.some(item => !this.isItemChecked(item))
    }
  },

  methods: {
    isItemChecked(item) {
      return this.value.includes(item.column)
    },

    onCheck(item, event) {
      if (event.target.checked) {
        const updatedValue = [...this.value, item.column].sort((a, b) => {
          const indexA = findIndex(this.config, { column: a })
          const indexB = findIndex(this.config, { column: b })

          if (indexA > indexB) {
            return 1
          }

          if (indexA < indexB) {
            return -1
          }

          return 0
        })

        this.$emit('input', updatedValue)
      } else {
        this.$emit('input', this.value.filter(column => column !== item.column))
      }
    },

    onRestoreDefaultsClick() {
      if (this.isFiltered) {
        this.$emit('reset')
      }
    }
  }
}
</script>
